import type { useTranslation } from 'react-i18next'
import type { BriefingStep } from '@/shared/briefing'
import type { RohsBriefingStep } from '../../utils/rohsLegislationBriefing'

export function toV2RohsBriefingStep(
  step: RohsBriefingStep,
  translate: ReturnType<typeof useTranslation>['t']
): BriefingStep {
  return {
    key: step.key,
    status: step.status,
    requiredness: step.requiredness,
    title: translate(
      `v2.pages.products.detail.rohsBriefing.steps.items.${step.key}.title`
    ),
    description: translate(
      `v2.pages.products.detail.rohsBriefing.steps.items.${step.key}.description`
    ),
    requirednessLabel: translate(
      `v2.pages.products.detail.rohsBriefing.requiredness.${step.requiredness}`
    ),
    completeCount: step.completeCount,
    totalCount: step.totalCount,
  }
}
